import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useExportStore } from "store/exportStore";
import ExportProgressWindow from "./ExportProgressWindow";
import { checkExportStatus, downloadExportFile } from "hooks/useExport";

const ExportProgressContainer = () => {
  const { exports, updateExport, removeExport } = useExportStore();

  // Poll for status updates on active exports
  useEffect(() => {
    const processingExports = exports.filter(
      (exp) => exp.status === "processing"
    );

    if (processingExports.length === 0) return;

    const pollInterval = setInterval(async () => {
      for (const exp of processingExports) {
        try {
          const statusData = await checkExportStatus(exp.exportId);
          
          if (statusData.status === "completed") {
            updateExport(exp.exportId, {
              status: "completed",
              filename: statusData.filename,
              downloadUrl: statusData.download_url,
            });
            
            // Auto download when completed
            try {
              await downloadExportFile(exp.exportId, statusData.filename);
              // Remove after successful download
              setTimeout(() => {
                removeExport(exp.exportId);
              }, 2000);
            } catch (error) {
              console.error("Auto download error:", error);
            }
          } else if (statusData.status === "failed") {
            updateExport(exp.exportId, {
              status: "failed",
              error: statusData.error || "エクスポートに失敗しました",
            });
          }
        } catch (error) {
          console.error("Status check error:", error);
        }
      }
    }, 2000); // Poll every 2 seconds

    return () => clearInterval(pollInterval);
  }, [exports, updateExport, removeExport]);

  if (exports.length === 0) return null;

  return (
    <Box
      position="fixed"
      bottom="20px"
      right="20px"
      zIndex={1000}
      maxH="80vh"
      overflowY="auto"
    >
      {exports.map((exp) => (
        <ExportProgressWindow
          key={exp.exportId}
          exportData={exp}
          onClose={() => removeExport(exp.exportId)}
        />
      ))}
    </Box>
  );
};

export default ExportProgressContainer;

